/* Auth routes: guest-only pages (sign up, sign in, 2FA, forgot) and link targets that work either way. */
import { page, type AreaRoutes } from '@/app/routes'

export const routes: AreaRoutes = {
  guest: [
    { path: 'signup', lazy: page(() => import('./pages/SignUpPage')) },
    { path: 'login', lazy: page(() => import('./pages/SignInPage')) },
    { path: 'login/2fa', lazy: page(() => import('./pages/TotpPage')) },
    { path: 'forgot-password', lazy: page(() => import('./pages/ForgotPasswordPage')) },
  ],
  public: [
    { path: 'check-email', lazy: page(() => import('./pages/CheckEmailPage')) },
    { path: 'verify-email', lazy: page(() => import('./pages/VerifyEmailPage')) },
    { path: 'reset-password', lazy: page(() => import('./pages/ResetPasswordPage')) },
  ],
}
